// V4 Global JavaScript

document.addEventListener('DOMContentLoaded', () => {
  // Reveal animations on scroll
  const revealElements = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  revealElements.forEach(el => observer.observe(el));

  // Smooth scroll for anchor links (only same-page hashes)
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});

// ============================================================
// V4 Cart Drawer
// ============================================================

(function() {
  const SECTION_ID = 'shopify-section-v4-cart-drawer';

  function getDrawer() { return document.getElementById('v4-cart'); }

  function syncShippingBar() {
    document.querySelectorAll('.v4-cart__shipping-bar[data-progress]').forEach(bar => {
      const fill = bar.querySelector('.v4-cart__shipping-fill');
      if (!fill) return;
      const progress = parseFloat(bar.dataset.progress) || 0;
      fill.style.setProperty('width', progress + '%', 'important');
    });
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    syncShippingBar();
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateHeaderCount(count) {
    let bubble = document.querySelector('.v4-header__cta-count');
    if (bubble) {
      if (count > 0) {
        bubble.textContent = count;
      } else {
        bubble.remove();
      }
    } else if (count > 0) {
      const cartLink = document.querySelector('.v4-header__cta');
      if (cartLink) {
        const span = document.createElement('span');
        span.className = 'v4-header__cta-count';
        span.textContent = count;
        cartLink.appendChild(span);
      }
    }
  }

  async function refreshDrawer({ openAfter = false } = {}) {
    try {
      const url = '/?sections=v4-cart-drawer&_=' + Date.now();
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      const html = data['v4-cart-drawer'];
      if (!html) return;

      // Swap only the panel's inner content so the .v4-cart element stays
      // stable (preserves is-open class and event handlers).
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html.trim();
      const newPanel = tempDiv.querySelector('.v4-cart__panel');
      const currentDrawer = getDrawer();
      if (newPanel && currentDrawer) {
        const currentPanel = currentDrawer.querySelector('.v4-cart__panel');
        if (currentPanel) currentPanel.innerHTML = newPanel.innerHTML;
      }

      if (openAfter) openDrawer();
      syncShippingBar();

      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        updateHeaderCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('v4:cart:updated', { detail: cart }));
      }

      // Cart page renders sections server-side; reload to sync subtotal/items.
      if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart?')) {
        window.location.reload();
      }
    } catch (err) {
      console.error('Cart drawer refresh failed', err);
    }
  }

  async function changeLineQty(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Cart change failed');
      }
      await refreshDrawer();
    } catch (err) {
      console.error(err);
    }
  }

  // ── Click outside the panel closes the drawer ──
  document.addEventListener('click', (e) => {
    const drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    // Don't close if click was on cart trigger or inside the panel
    if (e.target.closest('a.v4-header__cta')) return;
    if (e.target.closest('.v4-cart__panel')) return;
    closeDrawer();
  });

  // ── Open: click on header cart icon (anchor only, to avoid false matches) ──
  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('a.v4-header__cta');
    if (cartTrigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      return;
    }

    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('.v4-cart__line');
      if (!line) return;
      const input = line.querySelector('[data-line-qty]');
      if (!input) return;
      let qty = parseInt(input.value, 10) || 0;
      if (qtyBtn.dataset.cartQty === 'inc') qty++;
      else qty = Math.max(0, qty - 1);
      input.value = qty;
      changeLineQty(input.dataset.lineKey, qty);
      return;
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      changeLineQty(removeBtn.dataset.lineKey, 0);
      return;
    }
  });

  // ── Direct qty input change (debounced) ──
  let qtyTimeout = null;
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    clearTimeout(qtyTimeout);
    qtyTimeout = setTimeout(() => {
      changeLineQty(input.dataset.lineKey, parseInt(input.value, 10) || 0);
    }, 700);
  });

  // ── Close on Escape ──
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Sync shipping bar on initial load too
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncShippingBar);
  } else {
    syncShippingBar();
  }

  // Expose for quickadd handler below
  window.__v4Cart = { openDrawer, closeDrawer, refreshDrawer, updateHeaderCount, syncShippingBar };
})();

// ============================================================
// V4 Quick-add — AJAX add to cart, opens drawer on success
// ============================================================

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.matches('[data-v4-quickadd]')) return;
  e.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const textEl = button.querySelector('.v4-quickadd__text') || button;
  const originalText = textEl.textContent;

  if (button.disabled) return;
  button.disabled = true;
  button.classList.add('is-loading');
  textEl.textContent = 'Agregando…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Error');
    }

    button.classList.remove('is-loading');
    button.classList.add('is-success');
    textEl.textContent = '✓ Agregado';

    if (window.__v4Cart) {
      await window.__v4Cart.refreshDrawer({ openAfter: true });
    }

    setTimeout(() => {
      button.classList.remove('is-success');
      textEl.textContent = originalText;
      button.disabled = false;
    }, 1400);
  } catch (err) {
    button.classList.remove('is-loading');
    textEl.textContent = '✗ ' + (err.message || 'Error');
    setTimeout(() => {
      textEl.textContent = originalText;
      button.disabled = false;
    }, 2200);
  }
});
